import axios from "axios";

export const deleteLicense = async (licenseID: number) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API}/License/license?LicenseID=${licenseID}`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
